var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGenderIntersex = function SvgIconGenderIntersex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.125 3.25a1 1 0 1 1 0-2H19.5a1 1 0 0 1 1 1v3.375a1 1 0 1 1-2 0v-.961L16.743 6.42a6.627 6.627 0 0 1-4.493 10.254v1.45h2a1 1 0 1 1 0 2h-2v1.625a1 1 0 1 1-2 0v-1.625h-2a1 1 0 1 1 0-2h2v-1.45a6.627 6.627 0 0 1 1-13.175c1.565 0 3.002.542 4.136 1.45l1.7-1.7zM11.25 5.5a4.625 4.625 0 1 0 0 9.25 4.625 4.625 0 0 0 0-9.25",
    clipRule: "evenodd"
  })));
};
export default SvgIconGenderIntersex;